import React from "react";

export default class GrafanaFrame extends React.Component<any, any> {
    render() {
        return (
            <iframe title={"grafana"} src="https://dashboard.pengesoft.internal/grafana/" style={{width: "100%", height: "100%"}} />
        );
    }
}
